export const reelsConstants = {
  ASSIGN_REEL_EVENT: "ASSIGN_REEL_EVENT",
  GET_UNASSIGNED_REEL_EVENTS: "GET_UNASSIGNED_REEL_EVENTS",
  GET_ASSIGNED_REEL_EVENTS: "GET_ASSIGNED_REEL_EVENTS",
  REMOVE_ASSIGNED_REEL_SHUTTERB: "REMOVE_ASSIGNED_REEL_SHUTTERB",
  SET_IS_REEL_DETAIL_MODAL_OPEN: "SET_IS_REEL_DETAIL_MODAL_OPEN",
  SET_REEL_DETAIL_MODAL_EVENT_ID: "SET_REEL_DETAIL_MODAL_EVENT_ID",
  SET_REEL_DETAIL_MODAL_EVENT_GROUP_ID: "SET_REEL_DETAIL_MODAL_EVENT_GROUP_ID",
  GET_REEL_DETAILS: "GET_REEL_DETAILS",
  GET_REEL_TYPE_DETAILS: "GET_REEL_TYPE_DETAILS",
  GET_RECAP_TYPE_DETAILS: "GET_RECAP_TYPE_DETAILS",
  GET_REEL_TYPE_BY_ID: "GET_REEL_TYPE_BY_ID",
  ADD_REEL_TYPE: "ADD_REEL_TYPE",
  UPDATE_RECAP_TYPE: "UPDATE_RECAP_TYPE",
  UPDATE_REEL_TYPE: "UPDATE_REEL_TYPE",
  REMOVE_REEL_TYPE: "REMOVE_REEL_TYPE",
  SET_REEL_TYPE_VALUES: "SET_REEL_TYPE_VALUES",
  GET_RECAP_FEEDBACK: "GET_RECAP_FEEDBACK",
  DEFAULT_PAGINATION_PAGE_SIZE: 20,
  SET_REEL_DETAIL_MODAL_REEL_ID: "SET_REEL_DETAIL_MODAL_REEL_ID",
  RECAP_FEEDBACK_STATUS: {
    PENDING: "pending",
    COMPLETED: "completed",
  },

  GALLERY_ACTION_TYPES: {
    1: "add clip",
    2: "delete clip",
    3: "change clip",
    4: "song feedback"
  },
  GET_REELS_BY_EVENT_ID: "GET_REELS_BY_EVENT_ID",
  GET_REELS_BY_EVENT_GROUP_ID: "GET_REELS_BY_EVENT_GROUP_ID",
};
